import React, { useState } from 'react'

import { useTheme } from '@mui/material'
import Box from '@mui/material/Box'
import { useTranslation } from 'react-i18next'

import { CustomTabs, TabType } from '../../../components/Tabs'
import { CashFlowTable } from '../../CashFlow'
import { ClosedPositionsTable, OpenPositionsTable } from '../Positions'

export const Positions = () => {
  const { spacing, palette } = useTheme()
  const { t } = useTranslation()

  const [activeTab, setActiveTab] = useState<number>(0)

  const tabs: TabType<string>[] = [
    {
      key: 'openPositions',
      label: t('openPositions', 'Open positions'),
      component: <OpenPositionsTable />,
    },
    {
      key: 'closedPositions',
      label: t('closedPositions', 'Closed positions'),
      component: <ClosedPositionsTable />,
    },
    {
      key: 'cashFlows',
      label: t('cashFlow', 'Cash Flow'),
      className: 'tab-cash-flows',
      component: <CashFlowTable embedded />,
    },
  ]

  return (
    <Box
      className="dashboard-positions-table"
      p={spacing(3, 3, 0)}
      bgcolor={palette.background.paper}
      borderRadius={spacing(0.5)}
      mt={spacing(2)}
    >
      <CustomTabs tabs={tabs} activeTab={activeTab} setActiveTab={setActiveTab} />
      <Box m={spacing(0, -2)}>{tabs[activeTab].component}</Box>
    </Box>
  )
}
